<script setup lang="ts">
import { useI18n } from "vue-i18n";

import moment from "moment-timezone";

import type { MissionAlreadyConfirmed, WorkerAlreadyConfirmedModalProps } from "@/components/Mission/MissionSideModal/types";

import Button from "@/dsComponents/buttons/Button.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

const { t } = useI18n();

const props = defineProps<WorkerAlreadyConfirmedModalProps>();

const emit = defineEmits(["cancel", "confirm"]);

const getMissionLibelle = (missionAlreadyConfirmed: MissionAlreadyConfirmed) => {
    const dateFormat = "DD MMMM YYYY";
    const missionStartDate = moment(missionAlreadyConfirmed.startAt).format(dateFormat);
    const missionEndDate = moment(missionAlreadyConfirmed.endAt).format(dateFormat);

    return t("page.mission.modal.alreadyConfirmed.mission", {
        missionName: missionAlreadyConfirmed.name,
        missionStartDate: missionStartDate,
        missionEndDate: missionEndDate,
    });
};
</script>

<template>
    <Modal :open="props.isOpen" :title="t('page.mission.modal.alreadyConfirmed.title')" maxWidth="600px">
        <div class="worker-already-confirmed-modal">
            <div class="worker-already-confirmed-modal__content">
                <span class="worker-already-confirmed-modal__message typo-xm-regular">
                    {{
                        t("page.mission.modal.alreadyConfirmed.message", {
                            workerName: props.workerName,
                        })
                    }}
                </span>

                <span
                    v-for="(mission, index) in props.missionsAlreadyConfirmed"
                    :key="`worker-already-confirmed-modal-mission-${index}`"
                    class="worker-already-confirmed-modal__mission typo-xm-regular"
                >
                    {{ getMissionLibelle(mission) }}
                </span>

                <span class="worker-already-confirmed-modal__confirm typo-xm-regular">
                    {{ t("page.mission.modal.alreadyConfirmed.confirm") }}
                </span>
            </div>
        </div>
        <template #footer>
            <div class="worker-already-confirmed-modal__buttons">
                <Button size="sm" type="neutral" variant="stroke" :label="t('global.actions.cancel')" @click="emit('cancel')" />
                <Button size="sm" type="primary" variant="filled" :label="t('global.actions.confirm')" @click="emit('confirm')" />
            </div>
        </template>
    </Modal>
</template>

<style lang="scss" scoped>
.worker-already-confirmed-modal {
    &__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-md, 8px);
    }

    &__confirm {
        margin-top: var(--spacing-md, 8px);
    }

    &__buttons {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-md, 8px);
    }
}
</style>
